
import { Component, Vue } from 'vue-property-decorator';
@Component
export default class extends Vue {
  dates: (string | Date)[] = [];
  loading: boolean = false;
  onlineTable = [];
  private pickerBeginDateBefore: { disabledDate: Function } = {
    disabledDate(time: any) {
      return time.getTime() > Date.now();
    },
  };
  headRow({ row, column, rowIndex, columnIndex }: any) {
    if (columnIndex == 0 && rowIndex == 0) {
      return { 'border-bottom': 'none' };
    }
    return '';
  }
}
